import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateAgentDto } from './create-agent.dto';

/**
 * Update agent DTO
 */
export class UpdateAgentDto extends CreateAgentDto {
	@TransformInt()
	id!: number;
}
